/**
 * description:
 * author: 1580043700@qq.com
 * create_date: 2023/12/8-18:16
 */

import { Result } from 'antd'
import React from 'react'
import { useNavigate } from 'react-router-dom'

const PageMain: React.FC = () => {
  let navigate = useNavigate()

  const onBack = () => {
    navigate('/')
  }

  return (
    <div style={{ textAlign: 'center', height: '100%', backgroundColor: 'rgb(246, 248, 251)', borderRadius: '12px' }}>
      <Result
        status="404"
        title="404"
        subTitle="对不起, 您访问的页面不存在."
        // extra={
        //   <Button type="primary" onClick={onBack}>
        //     返回首页
        //   </Button>
        // }
      />
    </div>
  )
}

export default PageMain
